export default {
  namespaced: true,
  state:{
    dailyLettersAbsentGenders: [],
    dailyLettersAbsentGenderCreate: {
      modal: false,
      values: {}
    },
    dailyLettersAbsentGenderEdit: {
      modal: false,
      values: {}
    }
  },
  getters:{
    dailyLettersAbsentGenders(state){
      return state.dailyLettersAbsentGenders;
    },
    dailyLettersAbsentGenderCreate(state) {
        return state.dailyLettersAbsentGenderCreate;
    },
    dailyLettersAbsentGenderEdit(state) {
      return state.dailyLettersAbsentGenderEdit;
    }
  },
  mutations:{
    SET_DAILY_LETTERS_ABSENT_GENDERS(state, values){
      state.dailyLettersAbsentGenders = values;
    },
    SET_DAILY_LETTERS_ABSENT_GENDER_CREATE_MODAL(state, value) {
      state.dailyLettersAbsentGenderCreate.modal = value;
    },
    SET_DAILY_LETTERS_ABSENT_GENDER_CREATE_VALUES(state, value) {
      state.dailyLettersAbsentGenderCreate.values = value;
    },
    SET_DAILY_LETTERS_ABSENT_GENDER_EDIT_MODAL(state, value) {
      state.dailyLettersAbsentGenderEdit.modal = value;
    },
    SET_DAILY_LETTERS_ABSENT_GENDER_EDIT_VALUES(state, value) {
      state.dailyLettersAbsentGenderEdit.values = value;
    },
    PUSH_DAILY_LETTERS_ABSENT_GENDER(state, value){
      state.dailyLettersAbsentGenders.push(value);
    },
    SET_UPDATE_DAILY_LETTERS_ABSENT_GENDER(state, values){
      var editedIndex = state.dailyLettersAbsentGenders.map(absentGender => absentGender.id).indexOf(values.id);
      if (editedIndex > -1){
        Object.assign(state.dailyLettersAbsentGenders[editedIndex], values);
      }
      return;
    },
    SPLICE_DAILY_LETTERS_ABSENT_GENDER(state, value){
      let i = state.dailyLettersAbsentGenders.map(absentGender => absentGender.id).indexOf(value);
      state.dailyLettersAbsentGenders.splice(i, 1);
    }
  },
  actions:{
    getDailyLettersAbsentGenders({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('admin/daily-letters-absent-genders').then((response) => {
          commit('SET_DAILY_LETTERS_ABSENT_GENDERS', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    getCreateParams({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('admin/daily-letters-absent-genders/create').then((response) => {
          commit('SET_DAILY_LETTERS_ABSENT_GENDER_CREATE_VALUES', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    getEditParams({ commit, state }, id) {
      return new Promise((resolve, reject) => {
        axios.get(`admin/daily-letters-absent-genders/${id}/edit`).then((response) => {
          const currentValues = { ...state.dailyLettersAbsentGenderEdit.values };
          commit('SET_DAILY_LETTERS_ABSENT_GENDER_EDIT_VALUES', {
            ...currentValues,
            genders: response.data.data.genders
          });
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    dailyLettersAbsentGenderStore({commit}, payload) {
      const formData = new FormData();
      for(var key in payload) {
          formData.append(key, payload[key]);
      }
      return new Promise((resolve, reject) => {
        axios.post('admin/daily-letters-absent-genders', formData).then((response) => {
          commit('PUSH_DAILY_LETTERS_ABSENT_GENDER', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    dailyLettersAbsentGenderUpdate({commit}, payload) {
      var value = payload.id;
      return new Promise((resolve, reject) => {
        axios.put('admin/daily-letters-absent-genders/' + value, payload).then((response) => {
          commit('SET_UPDATE_DAILY_LETTERS_ABSENT_GENDER', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    deleteDailyLettersAbsentGender({ commit }, value) {
      return new Promise((resolve, reject) => {
        axios.delete('admin/daily-letters-absent-genders/' + value).then((response) => {
          commit('SPLICE_DAILY_LETTERS_ABSENT_GENDER', value);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
  }
}
